export default "__VITE_ASSET__8YGZGmvk__"